/**
 * The external dependencies.
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
// import { isEmpty } from 'lodash';

/**
 * The internal dependencies.
 */
import Landing from './modules/landing';
import Intro from './modules/intro';
import Results from './modules/results';
import Calculations from './modules/calculations';

/**
 * Install the plugins.
 */
Vue.use(VueRouter);

/**
 * Setup the router.
 */
const router = new VueRouter({
	routes: [Landing, Intro, Results, Calculations],
	linkActiveClass: '',
	mode: 'history'
});

/**
 * Set the document title.
 * @param  {Object} to
 * @param  {Object} from
 * @return {Void}
 */
router.afterEach((to, from) => {
	document.title = to.meta.title;
});

export default router;
